/** biome-ignore-all lint/suspicious/noConsole: this requires console */
import {ACTIONS} from './constants';

const ENABLE_DEBUG = !/evite.com/.test(self.location.origin);

const log = (...items) => {
  if (ENABLE_DEBUG) {
    if (typeof items[0] === 'string' && items.length === 1) {
      console.log(`%c${items[0]}`, 'color: cyan');
    } else {
      console.log(...items);
    }
  }
};

const error = (msg, err = null) => {
  console.error(msg, err || new Error(msg));
};

const contactsLists = {};

// Utils
function matchContact(term, contact) {
  const lowercaseTerm = term?.toLowerCase();
  return (
    contact.name?.toLowerCase()?.includes(lowercaseTerm) ||
    contact.email?.toLowerCase()?.includes(lowercaseTerm) ||
    contact.phone?.toLowerCase()?.includes(lowercaseTerm) ||
    contact.phone
      ?.toLowerCase()
      ?.replace(/[^0-9]/g, '')
      .includes(lowercaseTerm)
  );
}

function* filter(array, condition, maxSize) {
  let max = maxSize;
  if (!maxSize || maxSize > array.length) {
    max = array.length;
  }
  let count = 0;
  let i = 0;
  while (count < max && i < array.length) {
    if (condition(array[i])) {
      yield array[i];
      count++;
    }
    i++;
  }
}

// Actions
async function repopulateContacts(eventId) {
  try {
    const response = await fetch(`${self.location.origin}/ajax/event/${eventId}/contacts`, {
      method: 'get',
      credentials: 'include',
      headers: {Accept: 'application/json'},
      mode: 'cors',
    });
    contactsLists[eventId] = await response.json();
  } catch (err) {
    error('Failed to repopulate', err);
  }
}

function queryContacts(eventId, searchTerm, limit = Infinity) {
  if (!contactsLists[eventId]) {
    error(`Contacts list does not exist for "${eventId}"`);
    return [];
  }
  return Array.from(
    filter(contactsLists[eventId], (contact) => matchContact(searchTerm, contact), limit)
  );
}

self.onconnect = (connectEvent) => {
  log(`webworker connected!`);

  const port = connectEvent.ports[0];
  port.addEventListener('message', (event) => {
    // We use a more unique name for the action, since browser extensions and such also
    // post messages, and we don't want to conflict in the chance they use 'action'
    const {cdbaction: action, extras: {eventId, searchTerm, limit} = {}} = event.data || {
      extras: {},
    };
    if (action) {
      log(`Received message=${action}`);
      switch (action) {
        case ACTIONS.POPULATE: {
          log(`Repopulating contacts list for ${eventId}`);
          repopulateContacts(eventId).then(
            () => {
              port.postMessage({success: true});
            },
            (err) => {
              port.postMessage({success: false, error: err});
            }
          );
          break;
        }
        case ACTIONS.QUERY:
          {
            const results = queryContacts(eventId, searchTerm, limit);
            port.postMessage({results});
          }
          break;
        default:
          log(`Invalid action "${action}"!`);
          break;
      }
    }
  });
  port.start();
  log(`webworker port started`);
};
